import { Component, OnInit, Input, Inject, NgZone, ViewChild } from '@angular/core';
import { HoursService } from '../../services/hours.service';
import { DOCUMENT } from '@angular/common';
import { ActivatedRoute, Router, Event, NavigationEnd } from '@angular/router';
import { SearchComponent } from '../search/search.component';
import { VisitorMapAndHours, VisitorMapAndHoursList, VisitorMapAndHoursService } from '../../../generated';


@Component({
  selector: 'app-mobile-nav-parts',
  templateUrl: './mobile-nav-parts.component.html',
  styleUrls: ['./mobile-nav-parts.component.scss']
})
export class MobileNavPartsComponent implements OnInit {
  @ViewChild(SearchComponent, {static: true}) searchComponent: SearchComponent;
  @Input() includeLinks: boolean;
  marketHours: { 'shortLabel': string; 'daysOfWeek': number[]; 'hours': string; }[];
  today: { 'shortLabel': string; 'daysOfWeek': number[]; 'hours': string; };
  searchText = null;
  visitorMapAndHoursData: VisitorMapAndHours;

  constructor(private route: ActivatedRoute,
              private hoursService: HoursService,
              private readonly visitorMapAndHoursService: VisitorMapAndHoursService,
              @Inject(DOCUMENT) private document: Document) {
  }


  ngOnInit() {
    this.getVisitorMap();
  //console.log({ includeLinks: this.includeLinks });
  }

  goto(href, event) {
    // console.log('goto', href);
    window.open(href, '_blank');
    event.preventDefault();
    event.stopPropagation();
  }

  async getVisitorMap() {
    const visitorMapList: VisitorMapAndHoursList = await this.visitorMapAndHoursService.getOrgsOrgnameVisitormapandhours('global', true).toPromise();
    // console.log('DEBUG', visitorMapList);
    if (!!visitorMapList && !!visitorMapList[0]) {
      this.visitorMapAndHoursData = visitorMapList[0];
    }
    // console.log('VisitMap Data', this.visitorMapAndHoursData);
  }

  keyUp(event) {
    // console.log('search()', event);

    this.searchComponent.search(event, this.searchText);
  }
}
